<template>
    <el-container class="app-shell">
        <!-- 顶部导航 -->
        <el-header class="app-main-header no-select">
            <div class="app-header__left">
                <div class="app-header__logo" @click="home">
                    <img alt="logo" src="../assets/mascot/kip_base.png" />
                </div>

                <nav v-if="fullWidth > 700" class="app-header__nav">
                    <el-button v-for="item in navItems" :key="item.code" text size="small" class="nav-item"
                        :class="{ 'is-active': activeNavCode === item.code }" @click="gotoPage(item.page)">{{ $t(item.label) }}</el-button>
                </nav>
                <el-dropdown v-else class="nav-dropdown" trigger="click" popper-class="nav-dropdown-menu" @command="gotoPage">
                    <el-button text size="small" class="nav-item nav-item--current is-active">
                        {{ currentNav ? $t(currentNav.label) : '' }}
                        <el-icon><ArrowDown /></el-icon>
                    </el-button>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item v-for="item in navItems" :key="item.code" :command="item.page">
                                <span class="nav-emoji">{{ item.emoji }}</span>
                                {{ $t(item.label) }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>

            <div class="app-header__right">
                <template v-if="this.$store.state.user.token == undefined || this.$store.state.user.token == '' || this.$store.state.user.name == undefined || this.$store.state.user.name == ''">
                    <el-link class="header-link" :underline="false" @click="register">
                        <el-icon><User /></el-icon>
                        <span>注册</span>
                    </el-link>
                    <span class="header-divider"></span>
                    <el-link class="header-link" :underline="false" @click="login">登录</el-link>
                </template>
                <template v-else>
                    <el-link v-if="fullWidth > 700" class="header-link" :underline="false" @click="workbench">
                        <el-icon><Monitor /></el-icon>
                        <span>{{ $t('workbench') }}</span>
                    </el-link>
                    <span v-if="fullWidth > 700" class="header-divider"></span>
                    <el-dropdown popper-class="nav-dropdown-menu">
                        <el-link class="header-link header-link--user" :underline="false">
                            <el-avatar :size="24" :src="currentAvatar(this.$store.state.user.avatar)" shape="square" />
                            <span v-if="isShowName">{{ this.$store.state.user.name }}</span>
                            <el-icon><ArrowDown /></el-icon>
                        </el-link>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item>😀 hi~ {{ this.$store.state.user.name }}</el-dropdown-item>
                                <el-dropdown-item @click="workbench">
                                    <el-icon><Monitor /></el-icon>
                                    {{ $t('workbench') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click="changeLocale">
                                    <el-icon><Orange /></el-icon>
                                    {{ $t('changeLanguage') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click="changePasswordDialogVisible = true">
                                    <el-icon><Key /></el-icon>
                                    {{ $t('changePassword') }}
                                </el-dropdown-item>
                                <el-dropdown-item @click="logout">
                                    <el-icon><CircleClose /></el-icon>
                                    退出
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </template>
            </div>
        </el-header>

        <!-- 内容区域 -->
        <el-main class="app-main-body">
            <router-view />

            <el-backtop></el-backtop>
        </el-main>
    </el-container>

    <!-- 修改密码弹框 -->
    <el-dialog class="app-change-password-dialog" width="440" align-center v-model="changePasswordDialogVisible"
        @closed="resetChangePasswordForm">
        <template #header>
            <div class="password-dialog__head">
                <h3 class="password-dialog__title">修改密码</h3>
                <p class="password-dialog__subtitle">设置新的登录密码，修改后立即生效</p>
            </div>
        </template>
        <el-form ref="changePasswordFormRef" :model="changePasswordForm" :rules="changePasswordRules"
            label-position="top" class="password-form" @submit.prevent>
            <el-form-item label="新的密码" prop="password">
                <el-input v-model="changePasswordForm.password" type="password" size="large" maxlength="64"
                    autocomplete="off" show-password placeholder="请输入新密码">
                    <template #prefix>
                        <el-icon>
                            <Lock />
                        </el-icon>
                    </template>
                </el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="password2">
                <el-input v-model="changePasswordForm.password2" type="password" size="large" maxlength="64"
                    autocomplete="off" show-password placeholder="请再次输入新密码" @keyup.enter="changePassword">
                    <template #prefix>
                        <el-icon>
                            <Lock />
                        </el-icon>
                    </template>
                </el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="password-dialog__foot">
                <el-button size="large" @click="changePasswordDialogVisible = false">取 消</el-button>
                <el-button type="primary" size="large" :loading="changePasswordLoading" @click="changePassword">确 定
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import request from '../utils/request.js';
import { avatarImage } from '../utils/users.js';
import watermark from '../utils/watermark';
import { ElMessage } from 'element-plus';

export default {
    name: 'AppMain',
    components: {},
    data() {
        return {
            keyword: '',
            changePasswordDialogVisible: false,
            changePasswordLoading: false,
            changePasswordForm: {
                password: '',
                password2: ''
            },
            changePasswordRules: {
                password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                password2: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value !== this.changePasswordForm.password) {
                                callback(new Error('两次输入的密码不一致'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            isShowName: false,
            fullWidth: document.documentElement.clientWidth,
            functionCode: ['doc']
        };
    },
    computed: {
        // 顶部导航项，按后台配置的功能开关过滤
        navItems() {
            return [
                { code: 'doc', label: 'doc', page: 'preview', path: '/', emoji: '📄' },
                { code: 'file', label: 'file', page: 'fileshare', path: '/fileshare', emoji: '📁' },
                { code: 'code', label: 'code', page: 'javadoc', path: '/javadoc', emoji: '🍵' },
                { code: 'ssh', label: 'ssh', page: 'ssh', path: '/ssh', emoji: '💻' },
                { code: 'whiteboard', label: 'whiteboard', page: 'whiteboard', path: '/whiteboard', emoji: '🎨' },
                { code: 'dataview', label: 'dataview', page: 'dataview', path: '/dataview', emoji: '📊' },
                { code: 'ilink', label: 'ilink', page: 'ilink', path: '/ilink', emoji: '🔗' }
            ].filter(item => this.functionCode.includes(item.code));
        },
        // 当前所处的导航项，用于窄屏下展示
        currentNav() {
            const path = this.$route.path;
            const matched =
                path === '/'
                    ? this.navItems.find(item => item.path === '/')
                    : this.navItems.find(item => item.path !== '/' && path.startsWith(item.path));
            return matched || this.navItems[0];
        },
        // 顶部导航高亮项，工作台等不在导航内的页面不高亮
        activeNavCode() {
            const path = this.$route.path;
            if (path === '/') {
                return 'doc';
            }
            const matched = this.navItems.find(item => item.path !== '/' && path.startsWith(item.path));
            return matched ? matched.code : '';
        }
    },
    mounted() {
        // 从localStorage中获取locale
        const locale = localStorage.getItem('locale');
        if (locale) {
            this.$i18n.locale = locale;
        }

        this.getHomeFunctionCode();

        var user = this.$store.state.user;
        console.log('user info is: ');
        console.log(user);

        if (user && user.realName && user.email) {
            watermark.set(user.realName, user.email);
        }

        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    created() {},
    methods: {
        changeLocale() {
            const i18n = this.$i18n;
            console.log(`Locale now is: ${i18n.locale}`);
            if (i18n.locale === 'zh') {
                i18n.locale = 'en';
            } else {
                i18n.locale = 'zh';
            }
            // 保存到localStorage
            localStorage.setItem('locale', i18n.locale);

            // this.$forceUpdate();
        },
        getHomeFunctionCode() {
            return request({
                url: '/openapi/appconf/function',
                method: 'get',
                data: {}
            }).then(res => {
                if (res.code == 0 && res.count > 0) {
                    this.functionCode = res.data;
                }
                console.log(this.functionCode);
            });
        },
        handleResize(event) {
            this.fullWidth = document.documentElement.clientWidth;
            this.isShowName = this.fullWidth > 1000;
        },
        gotoPage(page) {
            if (page == 'preview') {
                // let routeData = this.$router.resolve({
                //     name: 'preview',
                //     params: {}
                // });
                // window.open(routeData.path, '_blank');
                this.$router.push({ path: '/', params: {} });
            }
            if (page == 'javadoc') {
                // let routeData = this.$router.resolve({
                //     name: 'javadoc',
                //     params: {}
                // });
                // window.open(routeData.path, '_blank');
                this.$router.push({ path: '/javadoc', params: {} });
            }
            if (page == 'fileshare') {
                this.$router.push({ path: '/fileshare', params: {} });
            }
            if (page == 'ssh') {
                this.$router.push({ path: '/ssh', params: {} });
            }
            if (page == 'whiteboard') {
                this.$router.push({ path: '/whiteboard', params: {} });
            }
            if (page == 'dataview') {
                this.$router.push({ path: '/dataview', params: {} });
            }
            if (page == 'ilink') {
                this.$router.push({ path: '/ilink', params: {} });
            }
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        handleChange(val) {
            console.log(val);
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        search() {
            // alert(base_server + '搜索内容~' + this.keyword);
        },
        home() {
            this.$router.push({ path: '/', params: {} });
        },
        workbench() {
            this.$router.push({ path: '/workbench', params: {} });
        },
        register() {
            this.$router.push({ path: '/register', params: {} });
        },
        login() {
            this.$router.push({ path: '/login', params: {} });
        },
        async logout() {
            await this.$store.dispatch('user/logout');
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        },
        changePassword() {
            this.$refs.changePasswordFormRef.validate(valid => {
                if (!valid) {
                    return;
                }
                this.changePasswordLoading = true;
                request({
                    url: '/user/changePassword',
                    method: 'post',
                    data: { password: this.changePasswordForm.password, password2: this.changePasswordForm.password2 }
                })
                    .then(res => {
                        if (res.code == 0) {
                            ElMessage({ message: '密码修改成功', type: 'success' });
                            this.changePasswordDialogVisible = false;
                        }
                    })
                    .finally(() => {
                        this.changePasswordLoading = false;
                    });
            });
        },
        resetChangePasswordForm() {
            this.changePasswordForm.password = '';
            this.changePasswordForm.password2 = '';
            this.$refs.changePasswordFormRef && this.$refs.changePasswordFormRef.clearValidate();
        },
        currentAvatar(createUserAvatar) {
            return avatarImage(createUserAvatar);
        }
    }
};
</script>

<style>
html,
body,
#app,
#root {
    height: 100%;
    margin: 0;
    padding: 0;
}
#app {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #1f2d3d;
}

.no-select {
    user-select: none;
}

.app-shell {
    height: 100%;
}

/* ---------- 顶部导航 ---------- */
.el-header.app-main-header {
    /* 与登录页、首页保持同一套视觉语言 */
    --hd-text: #1f2d3d;
    --hd-text-sub: #5b6a80;
    --hd-line: #e6eaf0;
    --hd-primary: #2f6fed;
    --hd-primary-light: #eaf1fd;

    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    height: 52px;
    padding: 0 18px;
    color: var(--hd-text);
    text-align: left;
    background-color: #ffffff;
    border-bottom: 1px solid var(--hd-line);
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.04);
}

.app-header__left,
.app-header__right {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}

/* 品牌 logo */
.app-header__logo {
    display: flex;
    align-items: center;
    margin-right: 4px;
    cursor: pointer;
}

.app-header__logo img {
    display: block;
    height: 34px;
    transition: transform 0.2s;
}

.app-header__logo:hover img {
    transform: scale(1.05);
}

/* 导航项：白底药丸，选中态用浅蓝底 + 主色文字 */
.app-header__nav {
    display: flex;
    align-items: center;
    gap: 4px;
}

.app-main-header .app-header__nav .nav-item,
.app-main-header .nav-item--current {
    height: 34px !important;
    margin: 0 !important;
    padding: 0 13px !important;
    border: 0 !important;
    border-radius: 9px !important;
    background-color: transparent !important;
    color: var(--hd-text-sub) !important;
    font-size: 13px;
    font-weight: 500;
    box-shadow: none !important;
    transition:
        background-color 0.2s,
        color 0.2s;
}

.app-main-header .app-header__nav .nav-item:hover,
.app-main-header .nav-item--current:hover {
    background-color: #f2f5fa !important;
    color: var(--hd-text) !important;
}

.app-main-header .nav-item.is-active {
    background-color: var(--hd-primary-light) !important;
    color: var(--hd-primary) !important;
}

.nav-item--current {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

/* ---------- 右侧：登录/注册、用户菜单 ---------- */
.app-header__right .header-link {
    font-size: 13px;
    color: var(--hd-text-sub);
    transition: color 0.2s;
}

.app-header__right .header-link:hover {
    color: var(--hd-primary);
}

/* el-link 的插槽包了一层 __inner，间距加在这里 */
.app-header__right .header-link .el-link__inner {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.header-link--user .el-link__inner {
    gap: 7px;
}

.header-link--user .el-avatar {
    border-radius: 7px;
    box-shadow: 0 0 0 1px var(--hd-line);
}

.header-divider {
    flex: 0 0 auto;
    width: 1px;
    height: 12px;
    background-color: var(--hd-line);
}

/* 窄屏导航下拉（弹层挂到 body，样式需保持非 scoped） */
.nav-dropdown-menu {
    min-width: 150px;
    padding: 6px;
    border: 1px solid var(--hd-line, #e6eaf0);
    border-radius: 12px;
    box-shadow: 0 12px 30px -12px rgba(28, 47, 84, 0.22);
}

.nav-dropdown-menu .nav-emoji {
    display: inline-block;
    width: 20px;
    margin-right: 6px;
    text-align: center;
}

.nav-dropdown-menu .el-dropdown-menu__item {
    height: 34px;
    padding: 0 10px;
    border-radius: 8px;
    font-size: 13px;
    color: #5b6a80;
}

.nav-dropdown-menu .el-dropdown-menu__item:not(.is-disabled):hover,
.nav-dropdown-menu .el-dropdown-menu__item:not(.is-disabled):focus {
    background-color: #eaf1fd;
    color: #2f6fed;
}

/* ---------- 内容区域 ---------- */
.el-main {
    /* 保留原有规则：避免影响各页面内部嵌套的 el-main */
    padding: 10px;
    text-align: left;
}

.el-main.app-main-body {
    padding: 14px 18px 22px;
    background-color: #f5f7fb;
}

/* ---------- 移动端适配 ---------- */
@media (max-width: 768px) {
    .el-header.app-main-header {
        padding: 0 12px;
    }

    .el-main.app-main-body {
        padding: 10px 12px 18px;
    }
}

/* ---------- 修改密码弹框（与登录页保持同一套视觉语言） ---------- */
.app-change-password-dialog {
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --password-line: #e6eaf0;
    --password-text-sub: #8a94a6;

    max-width: calc(100vw - 32px);
    border-radius: 14px;
    box-shadow: 0 18px 50px -12px rgba(28, 47, 84, 0.22);
}

.app-change-password-dialog .el-dialog__header {
    margin-right: 0;
    padding: 22px 24px 0;
}

.app-change-password-dialog .el-dialog__headerbtn {
    top: 14px;
    right: 14px;
}

.app-change-password-dialog .el-dialog__body {
    padding: 18px 24px 4px;
}

.app-change-password-dialog .el-dialog__footer {
    padding: 0 24px 22px;
}

.password-dialog__title {
    margin: 0;
    font-size: 17px;
    font-weight: 600;
    color: #1f2d3d;
}

.password-dialog__subtitle {
    margin: 6px 0 0;
    font-size: 12px;
    color: var(--password-text-sub);
}

.password-form .el-form-item {
    margin-bottom: 18px;
}

.password-form .el-form-item__label {
    padding-bottom: 6px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: var(--password-text-sub);
}

.password-form .el-input__wrapper {
    padding: 1px 14px;
    border-radius: 10px;
    background-color: #f7f9fc;
    box-shadow: 0 0 0 1px var(--password-line) inset;
    transition:
        box-shadow 0.2s,
        background-color 0.2s;
}

.password-form .el-input__wrapper:hover {
    box-shadow: 0 0 0 1px #cfd8e6 inset;
}

.password-form .el-input__wrapper.is-focus {
    background-color: #ffffff;
    box-shadow:
        0 0 0 1px var(--el-color-primary) inset,
        0 0 0 3px var(--el-color-primary-light-8);
}

.password-form .el-input__prefix {
    color: #9aa6b8;
}

.password-dialog__foot {
    display: flex;
    gap: 10px;
}

.password-dialog__foot .el-button {
    flex: 1 1 0;
    height: 40px;
    margin-left: 0;
    border-radius: 10px;
    font-size: 14px;
}

.password-dialog__foot .el-button--primary {
    box-shadow: 0 8px 18px -8px rgba(47, 111, 237, 0.65);
}
</style>
